import { useEffect, useState } from '@redneckz/uni-jsx/lib/hooks';
import { INITIAL_MOBILE_MODE } from './initialMobileMode.js';
export const useMobileMode = () => {
    const mq = `(max-width: 1024px)`;
    const [isMobileMode, setIsMobileMode] = useState(INITIAL_MOBILE_MODE);
    useEffect(() => {
        const mqList = globalThis.matchMedia?.(mq);
        const mqHandler = () => {
            setIsMobileMode(Boolean(mqList?.matches));
        };
        mqList?.addEventListener('change', mqHandler);
        if (mqList?.matches) {
            setIsMobileMode(Boolean(mqList.matches));
        }
        return () => {
            mqList?.removeEventListener('change', mqHandler);
        };
    }, []);
    return isMobileMode;
};
//# sourceMappingURL=useMobileMode.js.map